import { css, FlattenSimpleInterpolation } from 'styled-components';
/**
 * Applies the provided @param styles to both &:hover and &:focus-visible.
 * Hover styles are conditionally applied via a media query that determines whether or not the device supports such action.
 * This is done so touch based devices don't retain the hover styles upon interaction
 *
 * @param styles Css styles to be applied
 * @returns
 */
export const accessibleHover = (styles: FlattenSimpleInterpolation): FlattenSimpleInterpolation => css`
  &:focus-visible {
    ${styles};
  }

  @media (hover: hover) or (pointer: fine) {
    &:hover {
      ${styles}
    }
  }
`;
